import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UtilFns } from '@utils';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AutoFocusModule } from 'primeng/autofocus';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  templateUrl: './contact-us.component.html',
  styleUrls: ['./auth-shell.scss'],
  imports: [InputTextModule, ButtonModule, FormsModule, RouterModule, CommonModule, AutoFocusModule],
})
export class ContactUsComponent {
  error = '';
  success = false;
  working = false;
  company = '';
  email = '';
  firstname = '';
  lastname = '';
  message = '';
  phone = '';
  username = '';
  // Honeypot field — hidden from humans via CSS; bots that auto-fill every input
  // will populate it. Server silently drops any submission where this is non-empty.
  website = '';

  constructor(private authService: AuthService) { }

  async onSubmit() {
    this.error = '';
    // if (!UtilFns.validateEmail(this.email)) {
    //   this.error = "Email address is invalid";
    //   return;
    // }
    if (this.working) { return; }
    this.working = true;

    try {
      const { company, email, firstname, lastname, phone, message, username, website } = this;
      const body = { company, email, firstname, lastname, phone, message, username, website };
      await this.authService.sendContactUs(body);
      this.error = '';
      this.success = true;
      this.working = false;

    } catch (err: any) {
      if (err.status === 0) {
        this.error = 'Unable to contact server';
      } else {
        //   this._logger.log(error, 'error');
        this.error = UtilFns.getErrorMessage(err);
      }
      this.working = false;

    }
  }

}
